import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { RentigoNgxCommonModule } from '@rentigo/ngx-common';
import { RentigoNgxAuthorizationModule } from '@rentigo/ngx-authorization';
// import { NgxSignaturePadModule } from '@eve-sama/ngx-signature-pad'; // TODO: replace, no ng19 build
import { ChartComponent } from './chart/chart.component';
import { FilterElementComponent } from './filter/filter-element/filter.element.component';
import { FilterComponent } from './filter/filter.component';
import { LoaderComponent } from './loader/loader.component';
import { DashboardNotificationService } from './notification/notification.service';
import { DashboardNotificationComponent } from './notification/dashboard-notification.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { SharedMaterialModule } from './shared-material.module';
import { SpinnerComponent } from './spinner/spinner.component';
import { ColoredSpinnerComponent } from './colored-spinner/colored-spinner.component';
import { SelectComponent } from './select/select.component';
import { PhonePipe } from './phone.pipe';
import { ConfirmationDialogComponent } from './dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './dialog/confirmation-dialog.service';
import { ViewFileComponent } from './dialog/veiw-file/view-file.component';
import { IncomeSourceTypePipe } from './income-source-type.pipe';
import { ProgressStatusPipe } from './progress-status.pipe';
import { FileTypePipe } from './file-type.pipe';
import { FormatDateService } from './format-date-service/format-date.service';
import { FileSizePipe } from './file/file-size.pipe';
import { DragDropDirective } from './file/drag-drop.directive';
import { IncomeLevelPipe } from "./income-level.pipe";
import { ScreeningResultPipe } from '../security-deposit/residents/pipes/screening-result.pipe';
import { RefundConfirmationDialogComponent } from './dialog/refund-confirmation-dialog/refund-confirmation-dialog.component';
import { ProductTypePipe } from '../security-deposit/residents/pipes/product-type.pipe';
import { StandingPipe } from '../security-deposit/residents/pipes/standing.pipe';
import { LayoutComponent } from './layout/layout.component';
import { SidebarComponent } from './layout/sidebar.component';
import { ShellGlobalSearchComponent } from './layout/shell-global-search.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { StatusChipComponent } from './components/status-chip/status-chip.component';

@NgModule({
  imports: [
    BaseChartDirective,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    RentigoNgxCommonModule,
    RentigoNgxAuthorizationModule,
    SharedMaterialModule,
    NgScrollbarModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  declarations: [
    FilterComponent,
    FilterElementComponent,
    SpinnerComponent,
    ColoredSpinnerComponent,
    LoaderComponent,
    ChartComponent,
    PaginatorComponent,
    SelectComponent,
    PhonePipe,
    ConfirmationDialogComponent,
    ViewFileComponent,
    DashboardNotificationComponent,
    IncomeSourceTypePipe,
    ProgressStatusPipe,
    FileTypePipe,
    FileSizePipe,
    IncomeLevelPipe,
    ScreeningResultPipe,
    ProductTypePipe,
    StandingPipe,
    DragDropDirective,
    RefundConfirmationDialogComponent,
    LayoutComponent,
    SidebarComponent,
    ShellGlobalSearchComponent,
    PageHeaderComponent,
    StatusChipComponent
  ],
  providers: [],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    RentigoNgxCommonModule,
    RentigoNgxAuthorizationModule,
    SharedMaterialModule,
    FilterComponent,
    FilterElementComponent,
    SpinnerComponent,
    ColoredSpinnerComponent,
    LoaderComponent,
    ChartComponent,
    PaginatorComponent,
    SelectComponent,
    NgScrollbarModule,
    NgxMaskDirective,
    NgxMaskPipe,
    PhonePipe,
    ConfirmationDialogComponent,
    ViewFileComponent,
    DashboardNotificationComponent,
    IncomeSourceTypePipe,
    ProgressStatusPipe,
    FileTypePipe,
    FileSizePipe,
    IncomeLevelPipe,
    ScreeningResultPipe,
    ProductTypePipe,
    StandingPipe,
    DragDropDirective,
    RefundConfirmationDialogComponent,
    LayoutComponent,
    ShellGlobalSearchComponent,
    PageHeaderComponent,
    StatusChipComponent
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        SharedMaterialModule.forRoot().providers as Provider[],
        DatePipe,
        CurrencyPipe,
        FileSizePipe,
        DashboardNotificationService,
        ConfirmationDialogService,
        FormatDateService,
        provideNgxMask({ validation: false }),
        provideCharts(withDefaultRegisterables())
      ]
    };
  }
}
